<template>
  <li>
    <a :href="href" :class="isActive ? 'active' : ''">
      {{ title }}
    </a>
  </li>
</template>

<script>
  export default {
    name: 'BreadcrumbItem',
    props: {
      isActive: {
        type: Boolean,
        default: false
      },
      href: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>


// WEBPACK FOOTER //
// breadcrumb_item.vue?67942a79